import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { setIsPosPayment, setPosTerminal } from './reducers';

export const posTerminalSlice = createSlice({
  name: 'posTerminal',
  initialState,
  reducers: {
    setPosTerminal,
    setIsPosPayment,
    setResetPosTerminal: () => initialState,
  },
});
